import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UIRouterGlobals } from "@uirouter/core";
import { PlanTierService } from "../plan-tier/plan-tier.service";
import { RememberService } from "../remember/remember.service";
import { UpgradeModalService } from "../upgrade-modal/upgrade-modal.service";

@Component({
  selector: "ab-account-overview",
  templateUrl: "./account-overview.component.html",
})
export class AccountOverviewComponent implements OnInit {
  @Input() public projects: any;
  @Input() public user: any;

  public loadingComponents: number;
  public enabled: boolean;
  public dur: string;
  public lastN: string;
  public featureDisabled: boolean;
  public hasNoErrors: boolean;
  public hasNoDeploys: boolean;
  public hasNoRequests: boolean;
  public showSingleProjectAlert: boolean;

  private REMEMBER_CHART_DURATION_KEY = "accountOverview.chartDuration";
  private REMEMBER_CHART_LAST_N_KEY = "accountOverview.chartLastN";
  private REMEMBER_ADD_PROJECTS_KEY = "alerts.addProjects.hide";

  constructor(
    private $uiRouterGlobals: UIRouterGlobals,
    private changeDetector: ChangeDetectorRef,
    private planTierService: PlanTierService,
    private rememberService: RememberService,
    private upgradeModal: UpgradeModalService,
  ) {}

  public onLoading(count: number) {
    this.loadingComponents += count;
    this.enabled = this.loadingComponents === 0;
    this.changeDetector.detectChanges();
  }

  public onDurChange(params: any) {
    this.dur = params.dur;
    this.lastN = params.last_n;
    this.rememberService.set(this.REMEMBER_CHART_DURATION_KEY, params.dur);
    this.rememberService.set(this.REMEMBER_CHART_LAST_N_KEY, params.last_n);
  }

  public ngOnInit() {
    this.enabled = false;
    this.loadingComponents = 0;

    this.onDurChange({
      dur:
        this.$uiRouterGlobals.params.dur ||
        this.rememberService.get(this.REMEMBER_CHART_DURATION_KEY, "90d/1d"),
      last_n:
        this.$uiRouterGlobals.params.last_n ||
        this.rememberService.get(this.REMEMBER_CHART_LAST_N_KEY, "90"),
    });

    this.planTierService.features().subscribe((features: any) => {
      this.featureDisabled = !features.account_dashboard;
      this.fetchProjects();
      this.hasNoErrors = this.projects.every(
        (p: any) => p.lastNoticeAt == null,
      );
      this.hasNoDeploys = this.projects.every(
        (p: any) => p.lastDeployAt == null,
      );
      this.hasNoRequests = this.projects.every(
        (p: any) => p.lastRequestAt == null,
      );
      this.showSingleProjectAlert = this.shouldShowSingleProjectAlert(
        this.projects,
      );
    });
  }

  public openUpgradeModal($event: any) {
    this.upgradeModal.open($event);
  }

  public closeSingleProjectAlert() {
    this.rememberService.set(this.REMEMBER_ADD_PROJECTS_KEY, true);
    this.showSingleProjectAlert = false;
  }

  private fetchProjects() {
    if (this.featureDisabled) {
      this.projects = [];
      return;
    }

    this.projects = this.projects || [];
  }

  private shouldShowSingleProjectAlert(projects: any) {
    if (this.featureDisabled) {
      return false;
    }
    if (projects.length > 1) {
      return false;
    }
    if (projects.every((p: any) => !p.lastNoticeAt)) {
      return false;
    }

    return !this.rememberService.get(this.REMEMBER_ADD_PROJECTS_KEY, false);
  }
}
